import $ from "jquery";
import Rails from "rails-ujs";
import "init";

window.jQuery = $;
Rails.start();

$(function () {
  // YP subscribe: show email form on button click
  $(".yp-subscribe-btn").on("click", function () {
    var block = $(this).closest(".yp-subscribe-block");
    $(this).hide();
    block.find(".yp-email-form").removeClass("hidden");
    block.find("input[name=email]").focus();
  });

  // YP subscribe: check email and redirect
  $(".yp-email-form form").on("submit", function (e) {
    e.preventDefault();
    var form = $(this);
    var email = form.find("input[name=email]").val();
    var checkUrl = form.data("check-url");
    var checkoutUrl = form.data("checkout-url");
    var msg = form.siblings(".yp-email-message");

    $.post(checkUrl, { email: email }, function (data) {
      if (data.exists) {
        msg.removeClass("hidden").text(
          "Такой мейл уже есть, отправим тебя логинится через 5,4,3,2,1"
        );
        var count = 5;
        var interval = setInterval(function () {
          count--;
          msg.text(
            "Такой мейл уже есть, отправим тебя логинится через " + count
          );
          if (count <= 0) {
            clearInterval(interval);
            window.location.href = "/login";
          }
        }, 1000);
      } else {
        window.location.href = checkoutUrl + "?email=" + encodeURIComponent(email);
      }
    });
  });
});
